/* Happy Tykes — Pali theme interactions */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var nav = document.querySelector('[data-site-nav]');
    if (!nav) return;
    var toggle = nav.querySelector('[data-nav-toggle]');
    var backdrop = nav.querySelector('[data-nav-backdrop]');
    if (!toggle) return;

    function close() {
      nav.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    function open() {
      nav.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    toggle.addEventListener('click', function () {
      nav.classList.contains('nav-open') ? close() : open();
    });
    if (backdrop) backdrop.addEventListener('click', close);
    nav.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 820) close();
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (item) {
      var btn = item.querySelector('.q');
      var sign = item.querySelector('.pl');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isClosed = item.classList.toggle('closed');
        btn.setAttribute('aria-expanded', String(!isClosed));
        if (sign) sign.textContent = isClosed ? '+' : '–';
      });
    });
  }

  /* ---------- Countdown ring animation ---------- */
  function initRing() {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-ring]').forEach(function (svg) {
      var ring = svg.querySelector('[data-ring-progress]');
      var label = svg.querySelector('[data-ring-time]');
      if (!ring || !label) return;

      var C = 804; // ring circumference (2·π·128)
      var meridiem = svg.getAttribute('data-meridiem') || 'AM';
      var duration = (parseFloat(svg.getAttribute('data-duration')) || 6) * 1000;

      // Parse the wake-up (end) time, e.g. "7:30"
      var end = (svg.getAttribute('data-end-time') || '7:30').split(':');
      var endH = parseInt(end[0], 10) || 7;
      var endM = parseInt(end[1], 10) || 0;
      var endTotal = endH * 60 + endM;
      var startTotal = endTotal - 30; // count up over the final 30 minutes

      function fmt(totalMin) {
        var h = Math.floor(totalMin / 60);
        var m = totalMin % 60;
        return h + ':' + (m < 10 ? '0' + m : m);
      }

      if (prefersReduced) {
        ring.setAttribute('stroke-dashoffset', '0');
        label.textContent = fmt(startTotal);
        return;
      }

      var startTs = null;
      function frame(ts) {
        if (startTs === null) startTs = ts;
        var elapsed = ts - startTs;
        var p = Math.min(elapsed / duration, 1); // 0 → 1
        // ring depletes clockwise: full at start, empty (hidden) at end
        ring.setAttribute('stroke-dashoffset', String(-C * p));
        // time counts up from start to end
        var mins = Math.round(startTotal + (endTotal - startTotal) * p);
        label.textContent = fmt(mins);
        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          // hold briefly at the wake time, then loop
          setTimeout(function () { startTs = null; requestAnimationFrame(frame); }, 1100);
        }
      }

      // Only animate when scrolled into view
      if ('IntersectionObserver' in window) {
        var started = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !started) {
              started = true;
              requestAnimationFrame(frame);
              io.disconnect();
            }
          });
        }, { threshold: 0.35 });
        io.observe(svg);
      } else {
        requestAnimationFrame(frame);
      }
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-main-image]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
      if (!main || !thumbs.length) return;
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        main.src = t.getAttribute('data-full');
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        t.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
    });
  }

  /* ---------- Product tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-tab]');
      var panels = wrap.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
          tab.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('.pdp-stepper').forEach(function (st) {
      var input = st.querySelector('input');
      if (!input) return;
      var minus = st.querySelector('[data-qty-minus]');
      var plus = st.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* ---------- Header dropdowns ---------- */
  function initDropdowns() {
    var dds = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown]'));
    dds.forEach(function (dd) {
      var btn = dd.querySelector('[data-dropdown-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = dd.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        dds.forEach(function (o) { if (o !== dd) { o.classList.remove('is-open'); } });
      });
    });
    document.addEventListener('click', function (e) {
      dds.forEach(function (dd) { if (!dd.contains(e.target)) dd.classList.remove('is-open'); });
    });
  }

  /* ---------- Feature map (hotspots + lines) ---------- */
  function initFeatureMap() {
    document.querySelectorAll('[data-fmap]').forEach(function (map) {
      var hotspots = Array.prototype.slice.call(map.querySelectorAll('[data-fmap-hotspot]'));
      var callouts = Array.prototype.slice.call(map.querySelectorAll('[data-fmap-callout]'));
      var lines = Array.prototype.slice.call(map.querySelectorAll('[data-fmap-line]'));
      var panel = map.querySelector('[data-fmap-panel]');

      function setActive(idx, persist) {
        hotspots.forEach(function (h) { h.classList.toggle('is-active', h.getAttribute('data-index') === idx); });
        lines.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-index') === idx); });
        callouts.forEach(function (c) {
          var on = c.getAttribute('data-index') === idx;
          c.classList.toggle('is-active', on);
          c.classList.toggle('is-dim', !on);
        });
        if (panel && persist) {
          var src = callouts.filter(function (c) { return c.getAttribute('data-index') === idx; })[0]
                 || hotspots.filter(function (h) { return h.getAttribute('data-index') === idx; })[0];
          if (src) {
            var head = src.getAttribute('data-label') || '';
            var body = src.getAttribute('data-desc') || '';
            var ico = src.getAttribute('data-icon') || '';
            panel.innerHTML = '<div class="fc-head">' + ico + '<h4>' + head + '</h4></div><p>' + body + '</p>';
          }
        }
      }

      hotspots.forEach(function (h) {
        h.addEventListener('click', function () { setActive(h.getAttribute('data-index'), true); });
        h.addEventListener('mouseenter', function () {
          if (window.innerWidth > 820) setActive(h.getAttribute('data-index'), false);
        });
      });
      // reset dim state when leaving the stage (desktop)
      map.addEventListener('mouseleave', function () {
        if (window.innerWidth > 820) {
          callouts.forEach(function (c) { c.classList.remove('is-dim', 'is-active'); });
          lines.forEach(function (l) { l.classList.remove('is-active'); });
          hotspots.forEach(function (h) { h.classList.remove('is-active'); });
        }
      });
      // initialize mobile panel with first feature
      if (panel && hotspots.length) setActive(hotspots[0].getAttribute('data-index'), true);
    });
  }

  /* ---------- Video carousel ---------- */
  function initVideoCarousel() {
    document.querySelectorAll('[data-vcarousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-vtrack]');
      var prev = wrap.querySelector('[data-vprev]');
      var next = wrap.querySelector('[data-vnext]');
      function step() {
        var card = track && track.querySelector('.vcard');
        return card ? card.getBoundingClientRect().width + 18 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    });
    // click-to-play
    document.querySelectorAll('[data-vcard]').forEach(function (card) {
      var btn = card.querySelector('[data-vplay]');
      var vid = card.querySelector('video');
      if (!btn) return;
      btn.addEventListener('click', function () {
        card.classList.add('is-playing');
        if (vid) { vid.setAttribute('controls', ''); vid.play(); }
        var ifr = card.querySelector('iframe');
        if (ifr && ifr.dataset.src) ifr.src = ifr.dataset.src;
      });
    });
  }

  function init() {
    initNav();
    initFaq();
    initRing();
    initGallery();
    initTabs();
    initQty();
    initDropdowns();
    initFeatureMap();
    initVideoCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
